export default __webpack_public_path__ + "static/media/dark.784aa461.svg";